const calcEndianness = () => {
    const uInt32 = new Uint32Array([0x11223344]);
    const uInt8 = new Uint8Array(uInt32.buffer);

    switch (uInt8) {
        case 0x44:
            return false;
        case 0x11:
            return true;
    }
};

export const isBigEndian = calcEndianness();

export const fastHalve = (n) => (isBigEndian ? n << 1 : n >> 1);
export const fastQuarter = (n) => (isBigEndian ? n << 2 : n >> 2);

export const fastDouble = (n) => (isBigEndian ? n >> 1 : n << 1);
export const fastQuadruple = (n) => (isBigEndian ? n >> 2 : n << 2);
